export default __webpack_public_path__ + "static/media/website-07 1.c5c7321f.png";